// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container___12bTo","input":"input___3EUMH","link":"link___3RKD5","submit":"submit___2_C3y"};